import { render } from "./LoginBox.vue?vue&type=template&id=9b336096&scoped=true&ts=true&lang=pug"
import script from "./LoginBox.vue?vue&type=script&lang=ts"
export * from "./LoginBox.vue?vue&type=script&lang=ts"

import "./LoginBox.vue?vue&type=style&index=0&id=9b336096&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b336096"]])

export default __exports__